
import { useEffect } from "react";
import { clearInvoices, userActions } from '../helpers/store';
// @mui material components
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import { useNavigate } from 'react-router-dom';
// Argon Dashboard 2 MUI components
import ArgonBox from "../components/dashdata/ArgonBox";
import ArgonTypography from "../components/dashdata/ArgonTypography";
// Argon Dashboard 2 MUI examples
import DashboardLayout from "../components/dashdata/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../components/dashdata/Navbars/DashboardNavbar";
import Footer from "../components/dashdata/Footer";
import Sidenav from "../components/dashdata/Sidenav";
import logo from '../assets/images/logo.png'
import logomini from '../assets/images/logomini.png'


// Argon Dashboard 2 MUI base styles
import typography from "../assets/theme/base/typography";


import { setDirection } from "../slices/page.slice";
import { useSelector, useDispatch } from 'react-redux';
// Argon Dashboard 2 MUI contexts
import AppRoutes from '../AppRoutes';
import DetailedStatisticsCard from "../components/dashdata/Cards/StatisticsCards/DetailedStatisticsCard";
const Layout =({children }) =>{

  const dispatch = useDispatch();
  const pageData = useSelector(x => x.page);

  const navigate = useNavigate();
  useEffect(() => {
      dispatch(userActions.getAll());
      dispatch(setDirection("rtl"));

    return () => dispatch(setDirection("rtl"));
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <div>
    <Sidenav
    color={pageData.sidenavColor}
    brand={logo}
    brandMini={logomini}
    //brand={page.darkSidenav || page.darkMode ? page.brand : page.brandDark}
    brandName="پورتال مشتریان"
    //brandName="پورتال مشتریان عادل لنز"
    routes={AppRoutes}
    //onMouseEnter={handleOnMouseEnter}
    //onMouseLeave={handleOnMouseLeave}
  />
    <DashboardLayout>
        <DashboardNavbar appRoutes={AppRoutes} />
          <div>
              <main>{children}</main>
          </div>
      <Footer />
    </DashboardLayout>
    </div>
  );
}

export default Layout;
